"use client"

import { useState, useEffect } from "react"

const StroopTest = ({ onScore }) => {
  const [currentTask, setCurrentTask] = useState(0)
  const [selectedColor, setSelectedColor] = useState(null)
  const [showResult, setShowResult] = useState(false)
  const [streak, setStreak] = useState(0)
  const [timeLeft, setTimeLeft] = useState(10)
  const [gameActive, setGameActive] = useState(false)

  const colors = [
    { name: "КРАСНЫЙ", color: "#ef4444", bgColor: "#ef4444", value: "red" },
    { name: "СИНИЙ", color: "#3b82f6", bgColor: "#3b82f6", value: "blue" },
    { name: "ЗЕЛЁНЫЙ", color: "#22c55e", bgColor: "#22c55e", value: "green" },
    { name: "ЖЁЛТЫЙ", color: "#eab308", bgColor: "#eab308", value: "yellow" },
    { name: "ФИОЛЕТОВЫЙ", color: "#8b5cf6", bgColor: "#8b5cf6", value: "purple" },
    { name: "ОРАНЖЕВЫЙ", color: "#f97316", bgColor: "#f97316", value: "orange" },
  ]

  const generateTask = () => {
    const wordColor = colors[Math.floor(Math.random() * colors.length)]
    const textColor = colors[Math.floor(Math.random() * colors.length)]
    return {
      word: wordColor.name,
      wordColor: wordColor.value,
      textColor: textColor.color,
      correctAnswer: textColor.value,
    }
  }

  const [task, setTask] = useState(generateTask())

  // Таймер
  useEffect(() => {
    let interval
    if (gameActive && timeLeft > 0) {
      interval = setInterval(() => {
        setTimeLeft((prev) => prev - 1)
      }, 1000)
    } else if (timeLeft === 0) {
      setGameActive(false)
    }
    return () => clearInterval(interval)
  }, [gameActive, timeLeft])

  const startGame = () => {
    setGameActive(true)
    setTimeLeft(10)
    setStreak(0)
    setCurrentTask(0)
    setSelectedColor(null)
    setShowResult(false)
    setTask(generateTask())
  }

  const checkAnswer = () => {
    const correct = selectedColor === task.correctAnswer
    if (correct) {
      onScore(15)
      setStreak(streak + 1)
      setTimeout(() => {
        setTask(generateTask())
        setSelectedColor(null)
        setShowResult(false)
        setCurrentTask(currentTask + 1)
      }, 1500)
    } else {
      setStreak(0)
    }
    setShowResult(true)
  }

  const resetGame = () => {
    setGameActive(false)
    setTimeLeft(10)
    setStreak(0)
    setCurrentTask(0)
    setSelectedColor(null)
    setShowResult(false)
    setTask(generateTask())
  }

  return (
    <div className="lesson-card card-cyan">
      <h2 className="lesson-title" style={{ color: "#0e7490" }}>
        Тест Струпа 🎯
      </h2>
      <p style={{ textAlign: "center", fontSize: "1.125rem", color: "#4b5563", marginBottom: "24px" }}>
        Нажимай на цвет ТЕКСТА, а не на то, что написано!
      </p>

      {!gameActive && timeLeft === 10 ? (
        // Начальный экран
        <div style={{ textAlign: "center", display: "flex", flexDirection: "column", gap: "24px" }}>
          <div
            style={{
              backgroundColor: "white",
              padding: "24px",
              borderRadius: "8px",
              border: "2px solid #22d3ee",
            }}
          >
            <h3 style={{ fontSize: "1.5rem", fontWeight: "bold", marginBottom: "16px" }}>Как играть:</h3>
            <div style={{ display: "flex", flexDirection: "column", gap: "12px", fontSize: "1.125rem" }}>
              <p>1. Смотри на цвет букв, а не на слово! 👀</p>
              <p>2. Нажимай кнопку с цветом текста 🎨</p>
              <p>3. Будь быстрым и внимательным! ⚡</p>
            </div>
          </div>

          <div
            style={{
              backgroundColor: "#fef3c7",
              padding: "16px",
              borderRadius: "8px",
              border: "2px solid #f59e0b",
            }}
          >
            <p style={{ fontSize: "1.25rem", marginBottom: "8px" }}>Пример:</p>
            <div style={{ fontSize: "2.5rem", fontWeight: "bold", color: "#ef4444", margin: "16px 0" }}>СИНИЙ</div>
            <p style={{ fontSize: "1.125rem", marginBottom: "4px" }}>Слово "СИНИЙ", но написано КРАСНЫМ цветом</p>
            <p style={{ fontSize: "1.125rem", fontWeight: "bold", color: "#16a34a" }}>Правильный ответ: КРАСНЫЙ!</p>
          </div>

          <button
            onClick={startGame}
            className="nav-button primary"
            style={{ backgroundColor: "#22d3ee", fontSize: "1.5rem", padding: "24px 48px" }}
          >
            Начать игру! 🚀
          </button>
        </div>
      ) : gameActive ? (
        // Игровой экран
        <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
          {/* Статистика */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "16px", textAlign: "center" }}>
            <div
              style={{
                backgroundColor: "white",
                padding: "16px",
                borderRadius: "8px",
                border: "2px solid #e5e7eb",
              }}
            >
              <div style={{ fontSize: "1.5rem", fontWeight: "bold", color: "#3b82f6" }}>{timeLeft}</div>
              <div style={{ fontSize: "0.875rem" }}>Секунд</div>
            </div>
            <div
              style={{
                backgroundColor: "white",
                padding: "16px",
                borderRadius: "8px",
                border: "2px solid #e5e7eb",
              }}
            >
              <div style={{ fontSize: "1.5rem", fontWeight: "bold", color: "#16a34a" }}>{streak}</div>
              <div style={{ fontSize: "0.875rem" }}>Подряд</div>
            </div>
            <div
              style={{
                backgroundColor: "white",
                padding: "16px",
                borderRadius: "8px",
                border: "2px solid #e5e7eb",
              }}
            >
              <div style={{ fontSize: "1.5rem", fontWeight: "bold", color: "#8b5cf6" }}>{currentTask}</div>
              <div style={{ fontSize: "0.875rem" }}>Всего</div>
            </div>
          </div>

          {/* Задание */}
          <div
            style={{
              textAlign: "center",
              backgroundColor: "white",
              padding: "32px",
              borderRadius: "8px",
              border: "4px solid #22d3ee",
            }}
          >
            <p style={{ fontSize: "1.25rem", marginBottom: "16px" }}>Какого цвета этот текст?</p>
            <div style={{ fontSize: "4rem", fontWeight: "bold", color: task.textColor, marginBottom: "24px" }}>
              {task.word}
            </div>
            <p style={{ fontSize: "1.125rem", color: "#4b5563" }}>Нажми на цвет ТЕКСТА, не читай слово!</p>
          </div>

          {/* Кнопки выбора цветов */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "16px" }}>
            {colors.map((color) => (
              <button
                key={color.value}
                onClick={() => setSelectedColor(color.value)}
                disabled={showResult}
                style={{
                  backgroundColor: color.bgColor,
                  color: "white",
                  fontSize: "1.125rem",
                  padding: "24px",
                  borderRadius: "8px",
                  border: selectedColor === color.value ? "4px solid black" : "4px solid white",
                  cursor: showResult ? "not-allowed" : "pointer",
                  transform: selectedColor === color.value ? "scale(1.05)" : "scale(1)",
                  transition: "all 0.3s ease",
                }}
              >
                {color.name}
              </button>
            ))}
          </div>

          {/* Результат */}
          {showResult && (
            <div
              style={{
                textAlign: "center",
                fontSize: "1.5rem",
                fontWeight: "bold",
                color: selectedColor === task.correctAnswer ? "#16a34a" : "#dc2626",
              }}
            >
              {selectedColor === task.correctAnswer ? (
                <div>
                  🎉 Правильно!
                  {streak > 0 && <div style={{ fontSize: "1.125rem" }}>Подряд: {streak}!</div>}
                </div>
              ) : (
                <div>
                  ❌ Неправильно!
                  <div style={{ fontSize: "1.125rem" }}>
                    Правильный ответ: {colors.find((c) => c.value === task.correctAnswer)?.name}
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Кнопка проверки */}
          {!showResult && (
            <div style={{ textAlign: "center" }}>
              <button
                onClick={checkAnswer}
                disabled={selectedColor === null}
                className="nav-button primary"
                style={{ opacity: selectedColor === null ? 0.5 : 1, backgroundColor: "#22d3ee" }}
              >
                Проверить! ✨
              </button>
            </div>
          )}

          {/* Кнопка сброса */}
          <div style={{ textAlign: "center" }}>
            <button onClick={resetGame} className="nav-button secondary">
              Начать заново 🔄
            </button>
          </div>
        </div>
      ) : (
        // Экран окончания игры
        <div style={{ textAlign: "center", display: "flex", flexDirection: "column", gap: "24px" }}>
          <div
            style={{
              backgroundColor: "white",
              padding: "24px",
              borderRadius: "8px",
              border: "2px solid #22d3ee",
            }}
          >
            <h3 style={{ fontSize: "1.875rem", fontWeight: "bold", color: "#0e7490", marginBottom: "16px" }}>
              Время вышло! ⏰
            </h3>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "16px", fontSize: "1.25rem" }}>
              <div>
                <div style={{ fontSize: "1.875rem", fontWeight: "bold", color: "#16a34a" }}>{currentTask}</div>
                <div>Заданий выполнено</div>
              </div>
              <div>
                <div style={{ fontSize: "1.875rem", fontWeight: "bold", color: "#8b5cf6" }}>{streak}</div>
                <div>Лучшая серия</div>
              </div>
            </div>
          </div>

          <div
            style={{
              backgroundColor: "#fef3c7",
              padding: "16px",
              borderRadius: "8px",
              border: "2px solid #f59e0b",
            }}
          >
            <p style={{ fontSize: "1.25rem" }}>
              {currentTask >= 15
                ? "🏆 Отлично! Ты супер внимательный!"
                : currentTask >= 10
                  ? "🎉 Хорошо! Продолжай тренироваться!"
                  : currentTask >= 5
                    ? "👍 Неплохо! Можешь лучше!"
                    : "💪 Попробуй еще раз! Тренировка поможет!"}
            </p>
          </div>

          <button
            onClick={startGame}
            className="nav-button primary"
            style={{ backgroundColor: "#22d3ee", fontSize: "1.5rem", padding: "24px 48px" }}
          >
            Играть снова! 🎮
          </button>
        </div>
      )}
    </div>
  )
}

export default StroopTest
